import { CarrierType } from '@planning/app/api'
import { CompanyItemStore } from '@planning/rt-stores/externalDriver/CompanyItemStore'
import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import { NumericReleaseItemStore } from '@planning/rt-stores/numericRelease/NumericReleaseItemStore'
import { OrderItemStore } from '@planning/rt-stores/order/OrderItemStore'
import { RailVisitItemStore } from '@planning/rt-stores/railVisit/RailVisitItemStore'
import { VesselVisitItemStore } from '@planning/rt-stores/vesselVisit/VesselVisitItemStore'
import { computed, makeObservable } from 'mobx'
import { ReleaseDetailsViewStore } from './ReleaseDetailsViewStore'

export class NumericReleaseDetailsViewStore extends ReleaseDetailsViewStore {
  constructor(
    releaseId: number,
    private readonly numericReleaseItemStore: NumericReleaseItemStore,
    private readonly orderItemStore: OrderItemStore,
    private readonly railVisitItemStore: RailVisitItemStore,
    private readonly vesselVisitItemStore: VesselVisitItemStore,
    private readonly companyItemStore: CompanyItemStore,
  ) {
    super(releaseId)
    makeObservable(this, {
      numericRelease: computed,
      orders: computed,
    })
  }

  fetchOrders = async () => {
    if (!this.numericRelease) return

    const orderIds = this.numericRelease.data.assignedOrders?.map(order => order.id) ?? []

    if (orderIds.length === 0) return

    await this.orderItemStore.fetchByIds(orderIds)
  }

  fetchVisits = async () => {
    const numericRelease = this.numericRelease?.data
    if (!numericRelease?.carrierVisitId) return

    switch (numericRelease.modeOfTransport) {
      case CarrierType.Train:
        await this.railVisitItemStore.fetchById(numericRelease.carrierVisitId)
        return
      case CarrierType.Vessel:
        await this.vesselVisitItemStore.fetchById(numericRelease.carrierVisitId)
        return
    }
  }

  fetchTransportCompany = async () => {
    const release = this.numericRelease?.data

    const hasTransportCompany = release?.transportCompanyId
    const isTruckRelease = release?.modeOfTransport === CarrierType.Truck

    if (!isTruckRelease || !hasTransportCompany) return

    await this.companyItemStore.fetchById(release.transportCompanyId!)
  }

  get numericRelease(): INumericReleaseItem | null | undefined {
    return this.numericReleaseItemStore.elements[this.releaseId]
  }

  get orders() {
    if (!this.numericRelease) return []

    return this.numericRelease.orders
  }
}
